import * as swcHelpers from '@swc/helpers';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/utils';
import { getLineItemAvailability } from '../../../utils/get-line-item-availability.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/graphql';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import { toBaseLineItem } from './base-line-item.js';
import { getProductA11yLabel } from './utils/get-product-a11y-label.js';
import { getProductTitle } from './utils/get-product-title.js';
import { toBundleChildLineItem } from './utils/map-bundle-child-line-items.js';
import { getLineItemProduct } from './utils/get-line-item-product.js';

const toNonPrescriptionBundleCartLineItem = (lineItem, intl, settings)=>{
    // There are more bundled items in bundleLineItems than just the configurationBundle (aka offering)
    // but only the configurationBundle is needed for the view in cart and checkout
    const configurationBundleItem = lineItem.bundleLineItems.find((item)=>item.legacyProduct.productType === 'configurationbundle'
    );
    if (!configurationBundleItem) {
        throw new Error('Configuration bundle not found');
    }
    const product = getLineItemProduct(lineItem);
    const variant = product.masterData.current.variant;
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, settings, intl), {
        type: 'NON_PRESCRIPTION_BUNDLE',
        productType: 'non-prescription-bundle',
        title: getProductTitle(product, intl),
        altText: getProductA11yLabel(lineItem, intl),
        imageUrl: getLineItemImageUrl(variant),
        sku: lineItem.sku,
        bundleChildLineItems: [
            toBundleChildLineItem(intl)(configurationBundleItem)
        ]
    }, variant.availability ? {
        availability: getLineItemAvailability(variant.availability)
    } : {});
};

export { toNonPrescriptionBundleCartLineItem };
//# sourceMappingURL=non-prescription-bundle-line-item.js.map
